<app-form-element [control]="formControl" [id]="id" [label]="label" [required]="required" [twoColumns]="twoColumns">
  @if (!textArea) {
    <input
      [attr.aria-describedby]="ariaDescribedBy"
      [formControl]="formControl"
      [id]="id"
      [maxLength]="maxLength"
      pInputText
      type="text" />
  }

  @if (textArea) {
    <textarea
      [attr.aria-describedby]="ariaDescribedBy"
      [autoResize]="true"
      [formControl]="formControl"
      [id]="id"
      [maxLength]="maxLength"
      [rows]="1"
      [style]="{ width: '100%' }"
      pTextarea></textarea>
  }
</app-form-element>
